/**
 * ./src/modules/product/components/icons/IconChevronRight16.tsx
 *
 * IconChevronRight16 component to display an icon.
 *
 * @copyright DesignShop, 2024
 * @since 05/28/2024
 */
import React from 'react';

export const IconChevronRight16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.71677 3.71677C5.87298 3.56056 6.12624 3.56056 6.28245 3.71677L10.2825 7.71677C10.4387 7.87298 10.4387 8.12624 10.2825 8.28245L6.28245 12.2825C6.12624 12.4387 5.87298 12.4387 5.71677 12.2825C5.56056 12.1262 5.56056 11.873 5.71677 11.7168L9.43392 7.99961L5.71677 4.28245C5.56056 4.12624 5.56056 3.87298 5.71677 3.71677Z"
        fill="currentColor"
      />
    </svg>
  );
};
